import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { WhiteBoxModal } from '@hotelplan/components.common.modals';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import WishlistItemEditModalContent from 'components/domain/wishlist/WishlistItemEditModalContent';

interface IWishlistItemEditModalProps {
  onClose(): void;
  onRemove(): void;
  onMove(wishlistId: string): void;
}

const WishlistItemEditBaseModal = styled(WhiteBoxModal)(
  ({ theme: { FONT_SIZE } }) =>
    sx2CssThemeFn({
      '.modal-header': {
        py: [2, '14px'],
        px: ['20px', 4],
        ...FONT_SIZE.S,
      },
      '.modal-wrapper': {
        maxWidth: [null, '500px'],
        borderRadius: 'default',
        overflow: [null, 'hidden'],
      },
      '.modal-body': {
        px: [4, '50px'],
        py: [4, '30px'],
      },
    })
);

const WishlistItemEditModal: React.FC<IWishlistItemEditModalProps> = ({
  onMove,
  onClose,
  onRemove,
}) => {
  const [t] = useTranslation(['wishlist']);

  return (
    <WishlistItemEditBaseModal
      name="wishlist"
      show={true}
      title={t('wishlist:editOffer.title')}
      onClose={onClose}
    >
      <WishlistItemEditModalContent onRemove={onRemove} onMove={onMove} />
    </WishlistItemEditBaseModal>
  );
};

export default WishlistItemEditModal;
